import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { Grid } from 'planoplan-ui-kit/core/helpers/grid';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Points, paddingLevel } from '@styles';
import { Title } from '@components/Title';
import { Tags, Cards, Bottom } from './organism';
import { useTranslations } from '@libs/translations';
import {
  addPropsTags,
  filteredByTags,
  addTagsInProjects,
  slicePagination,
  findDescriptionTag,
  getQueryParams,
} from './helpers';

export const GalleryPage = ({ projects = [], tags = [], queryTags = {} }) => {
  const translations = useTranslations();
  const router = useRouter();
  const {
    locale,
    pathname,
    query: { page },
  } = useRouter();
  const currentPage = page ? Number(page) : 1;
  const pageCountPage = 12;

  const onChangePage = (page) => {
    const params = {};

    if (page !== 1) {
      params.page = page;
    }

    router.push({
      pathname,
      query: {
        ...getQueryParams(queryTags),
        ...params
      },
    });
  };

  const tagsStyle = addPropsTags({ type: 'style', tags, queryTags, locale });
  const tagsRoom = addPropsTags({ type: 'room', tags, queryTags, locale });
  const tagDescription = findDescriptionTag({ queryTags, tags });
  const projectsWithTags = addTagsInProjects({ projects, tags });
  const filteredProjects = filteredByTags({ projects: projectsWithTags, queryTags });
  const pageCount = Math.ceil(filteredProjects.length / pageCountPage);
  const prettyProjects = slicePagination({ projects: filteredProjects, currentPage, pageCountPage });

  const title = tagDescription ? tagDescription.title : (<span>{translations.t('site.galleryProjects.pageTitle')}<SymbolTitle>β</SymbolTitle></span>);
  return (
      <Container>
        <Wrapper>
          <Title>{title}</Title>
          <Tags tagsStyle={tagsStyle}
                tagsRoom={tagsRoom}/>
          <Cards tagDescription={tagDescription} projects={prettyProjects}/>
          <Bottom pageCount={pageCount} currentPage={currentPage} onChangePage={onChangePage} />
        </Wrapper>
      </Container>
  );
};

const Container = styled.section`
  ${paddingLevel('bottom', 'colar')};
  max-width: 1440px;
  margin: 0 auto;
  padding-top: 67.4px;
  position: relative;
  z-index: 2;

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: fixed;
    background-color: ${Colors.ivory};
    z-index: -1;
  }

  @media ${Points.tablet_portrait} {
    padding-top: 83.2px;
  }

  @media ${Points.laptop} {
    padding-top: 64px;
  }

  @media ${Points.fullhd} {
    padding-top: 84px;
  }
`;

const Wrapper = styled.div`
  ${Grid.post(2)};
  ${Grid.push(2)};
`;

const SymbolTitle = styled.span`
  color: #FFB540;
  padding-left: 8px;
  display: none;

  @media ${Points.laptop} {
    display: inline;
  }
`;
